export default "__VITE_ASSET__BsnHVCrg__"